<template>
    <div>
        <div class="data-table">
            <Role v-for="role in roles" :key="role.id" :role="role"></Role>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {FETCH_ROLES} from '@/store/modules/roles';
    import {SET_LOADING} from '@/store/modules/loader';
    import Role from '@/components/roles/Role';

    export default {
        components: { Role },

        mounted() {
            this.fetchData();
        },

        computed: {
            ...mapGetters([
                'currentUser',
                'roles'
            ]),

            hasRoles() {
                return this.roles.length > 0;
            }
        },

        data() {
            return {
                isLoading: false
            }
        },

        methods: {
            fetchData() {
                this.$store.dispatch(SET_LOADING, true);

                this.$store.dispatch(FETCH_ROLES).then(() => {
                    this.$store.dispatch(SET_LOADING, false);
                });
            },
        }
    }
</script>